import { IStorageService } from "../StorageService";
import { StorageKeys } from "../../common/Constants";

const SESSION_IDENTIFIER_STORAGE_KEY = "sessionid";
const LANGUAGE_STORAGE_KEY = "language";

let isLoggedIn: boolean | undefined = undefined;
let username: string = "";
let password: string = "";
let roles: Array<string> = [];
let applicantId: number = 0;

export interface ICredentialsService {
  setUsername(username: string): void;
  getUsername(): string;
  setIsLoggedIn(value: boolean): void;
  getIsLoggedIn(): Promise<boolean>;
  getSessionIdentifier(): Promise<string | null>;
  getUsernameFromStorage(): Promise<string | null>;
  setPassword(value: string): void;
  getPassword(): string;
  getLanguage(): Promise<number>;
  setLanguage(value: number): Promise<void>;
  getRoles(): Promise<string[]>;
  setRoles(value: any): void;
  saveUsernameToStorage(username: string): Promise<void>;
  savePasswordToStorage(password: string): Promise<void>;
  setApplicantId(value: number): void;
  getApplicantId(): number;
  saveTwoFactorAuthToStorage(value: boolean): Promise<void>;
  getTwoFactorAuthFromStorage(): Promise<boolean>;
  saveRolesToStorage(value: string[]): Promise<void>;
  getRolesFromStorage(): Promise<string[]>;
}

const CredentialsService = (storageService): ICredentialsService => {
  const _storageService: IStorageService = storageService;

  return {
    setUsername(value: string) {
      username = value;
    },

    getUsername() {
      return username;
    },

    async getIsLoggedIn() {
      if (isLoggedIn !== undefined) {
        return isLoggedIn;
      }
      let value = await storageService.get("loginStatus");

      isLoggedIn = value === "true";
      return isLoggedIn;
    },

    setIsLoggedIn(value: boolean) {
      isLoggedIn = value;
      _storageService.save("loginStatus", value);
    },

    async getSessionIdentifier() {
      return _storageService.get(SESSION_IDENTIFIER_STORAGE_KEY);
    },

    async getUsernameFromStorage() {
      return _storageService.get(StorageKeys.USERNAME);
    },

    setPassword(value: string) {
      password = value;
    },

    getPassword() {
      return password;
    },

    async getLanguage() {
      return _storageService.get(LANGUAGE_STORAGE_KEY);
    },

    async setLanguage(value: number) {
      _storageService.save(LANGUAGE_STORAGE_KEY, value);
    },

    async getRoles() {
      return roles;
    },

    async setRoles(value: Array<string>) {
      value.forEach((role) => {
        roles.push(role);
      });
    },

    async saveUsernameToStorage(username: string) {
      return _storageService.save(StorageKeys.USERNAME, username);
    },

    async savePasswordToStorage(password: string) {
      return _storageService.save(StorageKeys.PASSWORD, password);
    },

    setApplicantId(value: number) {
      applicantId = value;
    },

    getApplicantId() {
      return applicantId;
    },

    async saveTwoFactorAuthToStorage(value: boolean) {
      return _storageService.save(StorageKeys.TWO_FACTOR_AUTH, value);
    },

    async getTwoFactorAuthFromStorage() {
      return _storageService.get(StorageKeys.TWO_FACTOR_AUTH);
    },

    async saveRolesToStorage(value: string[]): Promise<void> {
      let roleList: string[] = [];
      value.forEach((role) => {
        roleList.push(role);
      });
      _storageService.save(StorageKeys.ROLES, roleList);
    },

    async getRolesFromStorage() {
      return _storageService.get(StorageKeys.ROLES);
    },
  };
};

export default CredentialsService;
